export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export enum ETravelType {
  /** На транспорте **/
  ByCar = 'byCar',
  /** Пешком **/
  ByFoot = 'byFoot',
}

export interface IHighway {
  distance: string;
  name: string;
}

export interface IRailway {
  distance: string;
  name: string;
}

export interface IUnderground {
  name: string;
  lineColor: string;
  time: string;
  transportType: ETransportType;
  underConstruction: boolean;
}

export interface IGeo {
  address: string;
  undergrounds: IUnderground[] | null;
  highways: IHighway[] | null;
  railways: IRailway[] | null;
}
